import AppLayout from '@amzn/awsui-components-react-v3/polaris/app-layout';
import React, {useEffect, useState} from 'react';
import {appLayoutNavigationLabels} from 'src/common/labels';
import {ServiceNavigation} from 'src/components/navigation';
import 'src/styles/index.scss';
import {AppRoutes, BreadcrumbGroupWithRouter} from "src/components/common/router-common";
import {BreadcrumbGroupProps} from "@amzn/awsui-components-react-v3/polaris/breadcrumb-group/interfaces";
import {Box, Container, Header, Tiles} from "@amzn/awsui-components-react-v3";
import {TilesProps} from "@amzn/awsui-components-react-v3/polaris/tiles/interfaces";
import {CreateAdhocTicket} from "src/components/wim/create-adhoc-ticket";
import {SwoUiMetrics} from "src/utils/swo-ui-metrics/swo-ui-metrics";
import {metricFeaturesList, metricPageNames} from "src/constants/swo-ui-metric-constants";

export default function CreateWorkitem() {

    const createAdhocTicket: TilesProps.TilesDefinition = {
        value: 'Workitem',
        label: 'Create Adhoc Workitem',
        description:
            'Use this option to create adhoc workitem.'
    }

    const items: ReadonlyArray<TilesProps.TilesDefinition> = [createAdhocTicket]

    const [selectedOption, setSelectedOption] = useState<string>(createAdhocTicket.value);
    useEffect(() => {
        SwoUiMetrics.publishCloudWatchCountMetric(metricFeaturesList.index, metricPageNames.createAdhocTicket)
    }, [])

    const bcItems: Array<BreadcrumbGroupProps.Item> = [
        {
            "text": "Home",
            "href": AppRoutes.home
        },
        {
            "text": "Create Workitem",
            "href": "#"
        }
    ]

    return (
        <AppLayout
            navigation={<ServiceNavigation/>}
            content={<>
                <Container header={<Header variant={"h2"}>Please select</Header>}>
                    <Tiles
                        data-testid="create-ticket-tiles"
                        items={items}
                        value={createAdhocTicket.value}
                    />
                </Container>
                {selectedOption === createAdhocTicket.value && <Box><CreateAdhocTicket /></Box>}
            </>}
            breadcrumbs={<BreadcrumbGroupWithRouter items={bcItems}/>}
            contentType="form"
            disableContentPaddings={false}
            toolsHide={true}
            ariaLabels={appLayoutNavigationLabels}
            maxContentWidth={Number.MAX_VALUE}
        />
    );
}